module.exports = __webpack_public_path__ + "img/TikTok-Wholesalelogo.e950f9dd.svg";